// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Wd","title":"Xd"};